<template>
  <div id="FactEducationPlan" class="section">
    <!-- INSERT MODE -->
    <div v-if="!edited">
      <div v-if="children.length > 0" class="columns is-multiline is-mobile">
        <!-- PERSONAL INFO. -->
        <div v-for="(kid, index) in children" :key="index" class="column is-12">
          <p class="title is-4 has-text-left">
            ข้อมูลบุตร {{ kid.name }} อายุ {{ kid.dob | yearolds }} ปี
          </p>
          <div class="column is-5" style="padding: 0 1rem 1rem 0;">
            <b-field label="เตรียมเงินไว้แล้ว" class="has-text-left">
              <b-input type="number" v-model="kid.prepare_cost" />
            </b-field>
          </div>

          <div
            :key="index"
            v-for="(plan, index) in kid.plans"
            class="columns has-text-left"
          >
            <div class="column">
              <div class="columns is-multiline is-align-end">
                <div class="column is-2-desktop is-4-tablet is-6-mobile">
                  <b-field label="หลักสูตร">
                    <b-select v-model="plan.education_lv">
                      <option
                        v-for="(option, index) in education_options"
                        :value="option"
                        :key="index"
                      >
                        {{ option }}
                      </option>
                    </b-select>
                  </b-field>
                </div>

                <div class="column is-3-desktop is-4-tablet is-6-mobile">
                  <b-field label="ชื่อโรงเรียน">
                    <b-input type="text" v-model="plan.school_name" />
                  </b-field>
                </div>
                <div class="column is-3-desktop is-4-tablet is-6-mobile">
                  <b-field label="ค่าเทอม (ต่อปี)">
                    <b-input type="number" v-model="plan.tuition_fee" />
                  </b-field>
                </div>
                <div class="column is-2-desktop is-4-tablet is-6-mobile">
                  <b-field label="จำนวนปีที่เรียน">
                    <b-input type="number" v-model="plan.duration" />
                  </b-field>
                </div>

                <div class="column is-2-desktop is-4-tablet is-6-mobile">
                  <b-field label="เงินเฟ้อ (%)">
                    <b-input type="number" v-model="plan.inflation" />
                  </b-field>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="columns is-multiline is-mobile">
        <div class="column is-12">
          <p class="title is-4 has-text-centered">
            ไม่พบข้อมูลบุตร
          </p>
        </div>
      </div>
    </div>
    <!-- EDIT MODE -->
    <div v-else>
      <div
        v-if="existingChildren && existingChildren.length > 0"
        class="columns is-multiline is-mobile"
      >
        <!-- PERSONAL INFO. -->
        <div
          :key="index"
          class="column is-12"
          v-for="(kid, index) in existingChildren"
        >
          <p class="title is-4 has-text-left">
            ข้อมูลบุตร {{ kid.name }} อายุ {{ kid.dob | yearolds }} ปี
          </p>
          <div class="column is-5" style="padding: 0 1rem 1rem 0;">
            <b-field label="เตรียมเงินไว้แล้ว" class="has-text-left">
              <b-input type="number" v-model="kid.prepare_cost" />
            </b-field>
          </div>

          <div
            :key="index"
            v-for="(plan, index) in kid.plans"
            class="columns has-text-left"
          >
            <div class="column">
              <div class="columns is-multiline is-align-end">
                <div class="column is-2-desktop is-4-tablet is-6-mobile">
                  <b-field label="หลักสูตร">
                    <b-input type="text" v-model="plan.education_lv" />
                  </b-field>
                </div>

                <div class="column is-3-desktop is-4-tablet is-6-mobile">
                  <b-field label="ชื่อโรงเรียน">
                    <b-input type="text" v-model="plan.school_name" />
                  </b-field>
                </div>
                <div class="column is-3-desktop is-4-tablet is-6-mobile">
                  <b-field label="ค่าเทอม (ต่อปี)">
                    <b-input type="number" v-model="plan.tuition_fee" />
                  </b-field>
                </div>
                <div class="column is-2-desktop is-4-tablet is-6-mobile">
                  <b-field label="จำนวนปีที่เรียน">
                    <b-input type="number" v-model="plan.duration" />
                  </b-field>
                </div>

                <div class="column is-2-desktop is-4-tablet is-6-mobile">
                  <b-field label="เงินเฟ้อ (%)">
                    <b-input type="number" v-model="plan.inflation" />
                  </b-field>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="columns is-multiline is-mobile">
        <div class="column is-12">
          <p class="title is-4 has-text-centered">
            ไม่พบข้อมูลบุตร
          </p>
        </div>
      </div>
    </div>
    <div class="btn-mt">
      <div class="columns is-centered">
        <div class="column is-2-desktop is-4-tablet is-12-mobile">
          <b-button
            outlined
            expanded
            class="prompt-font"
            @click.prevent="backwardStep()"
            >ย้อนกลับ
          </b-button>
        </div>
        <div v-if="edited" class="column is-2-desktop is-4-tablet is-12-mobile">
          <b-button
            outlined
            expanded
            type="is-primary"
            class="prompt-font"
            @click.prevent="updateFactInfoState()"
          >
            บันทึก
          </b-button>
        </div>
        <div class="column is-2-desktop is-4-tablet is-12-mobile">
          <b-button
            expanded
            type="is-primary"
            class="prompt-font"
            @click.prevent="saveFactInfoState()"
          >
            ต่อไป
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Helpers from "@/utils/Helper";
import { mapState, mapGetters, mapMutations } from "vuex";

export default {
  name: "FactEducationPlan",
  props: ["edited"],
  filters: {
    yearolds: function(value) {
      if (!value) return "";
      return Helpers.ageCalculator(value);
    }
  },
  computed: {
    ...mapState(["client", "factsheet_kids_education"]),
    ...mapGetters(["children"])
  },
  data() {
    return {
      existingChildren: null,
      education_options: [
        "อนุบาล",
        "ประถมศึกษา",
        "มัธยมศึกษา",
        "อาชีวศึกษา",
        "ปริญญาตรี หรือเทียบเท่า",
        "ปริญญาโท",
        "ปริญญาเอก"
      ]
    };
  },
  methods: {
    ...mapMutations({
      setFactSheetKidEducation: "SET_FACTSHEET_KID_EDUCATION"
    }),
    /* For Display Existing Information */
    setUpEducationInfo(education_info) {
      this.kids = [];
      let children_from_db = this.client.family.child;
      if (education_info.length == 0) {
        this.existingChildren = Helpers.generateChildrenDummdyList(
          children_from_db
        );
      } else {
        if (education_info.length !== children_from_db.length) {
          this.existingChildren = [];
          children_from_db.forEach(child => {
            const index = education_info.findIndex(
              selected => selected.sequence === child.sequence
            );
            if (index === -1) {
              const dummy = Helpers.createChildrenDummdyData(child);
              this.existingChildren.push(dummy);
            } else {
              this.existingChildren.push(education_info[index]);
            }
          });
        } else {
          this.existingChildren = education_info;
        }
      }
    },
    /* Button Action Handler */
    saveFactInfoState: function() {
      if (!this.edited) {
        const plan_education = this.createFactInfoEducatinoObject();
        this.setFactSheetKidEducation(plan_education);
      }
      this.$emit("form_completed");
    },
    updateFactInfoState: function() {
      if (this.edited) {
        const plan_education = this.createFactInfoEducatinoObject();
        this.setFactSheetKidEducation(plan_education);
        this.$emit("existing_sheet_updated");
      }
    },
    backwardStep: function() {
      this.$emit("back");
    },
    /* API & PARAMS*/
    createFactInfoEducatinoObject: function() {
      if (this.edited) {
        this.existingChildren.forEach(child => {
          const filtered = child.plans.filter(
            plan => plan.education_lv !== null
          );
          child.plans = filtered;
        });
        return this.existingChildren;
      } else {
        this.children.forEach(child => {
          const filtered = child.plans.filter(
            plan => plan.education_lv !== null && plan.education_lv !== ""
          );
          child.plans = filtered;
        });
        return this.children;
      }
    }
  },
  beforeMount() {
    if (this.edited) {
      this.setUpEducationInfo(this.factsheet_kids_education);
    }
  }
};
</script>
